export default {"src":"/_next/static/media/magic-stick.c3787970.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};